import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { forkJoin, Subject, takeUntil } from "rxjs";
import { DocumentoAllegato } from "src/app/common/models/documento-allegato";
import { FascicoloFull } from "src/app/common/models/fascicolo/fascicolo-full";
import { DialogConfig } from "src/app/core/components/dialog/dialog-config";
import { OperationsService } from "src/app/core/services/operations.service";
import { DocPreviewUtilityService } from "../../file-preview/doc-preview-utility.service";
import { mimeExtensionMap } from "../../file-preview/eml/eml-preview.component";
import { DialogRef } from "src/app/core/components/dialog/dialog-ref";
import { UpdateMetadatiDocumentoRequest } from "src/app/common/models/dto/update-metadati-documento-request";
import { DataInput } from "src/app/common/models/dto/data-input";
import { Pratica } from "src/app/common/models/pratica/pratica";
import { TipoTipologica } from "src/app/common/models/tipologiche/tipo-tipologica";
import { Pagination } from "src/app/common/models/pagination";
import { SpinnerService } from "../../spinner-load/spinner.service";

@Component({
  selector: "app-update-metadati-conservazione",
  templateUrl: "./update-metadati-conservazione.component.html",
  styleUrls: ["./update-metadati-conservazione.component.css"],
})
export class UpdateMetadatiConservazioneComponent implements OnInit, OnDestroy {
  fascicolo: FascicoloFull = null;
  pratica: Pratica = null;
  documenti: DocumentoAllegato[] = [];
  selectedDocs: DocumentoAllegato[] = [];
  motivoAssenzaFirma: TipoTipologica = null;
  modalitaFormazioneDocumento: TipoTipologica = null;
  currentPage: number = 0;
  currentItemsPerPage: number = 10;
  documentiPaged: DocumentoAllegato[] = [];
  loading: boolean = false;
  documentiOriginal: DocumentoAllegato[] = [];
  modalitaFormazOptions = [
    {
      id: "A",
      label: "A - Creazione tramite l’utilizzo di strumenti software",
      value: "A",
    },
    {
      id: "B",
      label:
        "B - Acquisizione di un documento informatico / acquisizione della copia per immagine/informatica di un documento analogico",
      value: "B",
    },
    {
      id: "C",
      label:
        "C - Transazioni o processi informatici o presentazione telematica di dati attraverso moduli o formulari",
      value: "C",
    },
    {
      id: "D",
      label:
        "D - Generazione o raggruppamento, anche in via automatica, di un insieme di dati o registrazioni",
      value: "D",
    },
  ];
  firmaOptions = [
    { id: "A", label: "Firma omessa ai sensi di legge", value: "A" },
    { id: "B", label: "Privo di firma", value: "B" },
    {
      id: "C",
      label:
        "Copia informatica di originale analogico sottoscritto in forma autografa",
      value: "C",
    },
  ];
  private destroy$ = new Subject<void>();
  constructor(
    private dialogConfig: DialogConfig,
    private operations: OperationsService,
    private docPreview: DocPreviewUtilityService,
    private dialogRef: DialogRef,
    private cdr: ChangeDetectorRef,
    private spinner: SpinnerService
  ) {}

  ngOnInit(): void {
    this.fascicolo = this.dialogConfig.data.fascicolo;
    this.pratica = this.dialogConfig.data.pratica;
    this.operations
      .fetchDocumentazioneFormata(this.fascicolo.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
       next: (res) => {
          this.documenti = res.documentiFascicolo.map(doc => ({
            ...doc,
            metadatoDocumento: doc.metadatoDocumento ?? {}
          }));
          this.documentiOriginal = JSON.parse(JSON.stringify(this.documenti));
          this.setCurrentConfigurazioni();
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isFilePresent(documento): boolean {
    return documento?.missingFile !== true;
  }

  canViewFile(documento: DocumentoAllegato) {
    return this.docPreview.canViewFile(documento);
  }

  findMaxSizeByContentype(contentType) {
    return this.docPreview.findMaxSizeByContentype(contentType);
  }

  checkMaxLimitExceeded(documento: DocumentoAllegato): boolean {
    return this.docPreview.checkMaxLimitExceeded(documento);
  }

  viewDoc(documento: DocumentoAllegato) {
    const filename = documento.nomeFile;
    const extension = filename.substring(filename.lastIndexOf(".") + 1);
    let mimeTypes = mimeExtensionMap;
    this.previewNavigate(
      documento,
      mimeTypes[documento.contentType] || extension,
    );
  }

  previewNavigate(documento: DocumentoAllegato, contentType: string) {
    this.docPreview.previewNavigate(documento, contentType);
  }

  add(event: { value: boolean; document: DocumentoAllegato }) {
    const isArchive = this.isArchive(event.document);
    const isFirmato = event.document.metadatoFirmaDocumenti?.length > 0;
    if (event.value) {
      if (
        !!this.motivoAssenzaFirma &&
        event.document.metadatoDocumento &&
        !isArchive &&
        !isFirmato
      ) {
        event.document.metadatoDocumento.motivoAssenzaFirma = this.motivoAssenzaFirma;
      }
      if(!!this.modalitaFormazioneDocumento && event.document.metadatoDocumento) {
        event.document.metadatoDocumento.modalitaFormazioneDocumento = this.modalitaFormazioneDocumento;
      }
      //this.handleProduttoreEsterno(event.document);
      this.cdr.detectChanges();
      this.selectedDocs.push(event.document);
    } else {
      let index = this.selectedDocs.findIndex(
        (x) => x.id === event.document.id,
      );
      this.selectedDocs.splice(index, 1);
    }
    event.document["selected"] = event.value;
    
  }

  selectAll(event: boolean) {
    if (!event) {
      this.documenti.forEach(doc => doc["selected"] = false);
      this.selectedDocs = [];
      return;
    }
    this.documenti.forEach(doc => {
      const isArchive = this.isArchive(doc);
      const isFirmato = doc.metadatoFirmaDocumenti?.length > 0;   
      if (this.modalitaFormazioneDocumento && doc.metadatoDocumento) {
        doc.metadatoDocumento.modalitaFormazioneDocumento =
          this.modalitaFormazioneDocumento;
      }

      if (
        this.motivoAssenzaFirma &&
        !isArchive &&
        !isFirmato
      ) {
      doc.metadatoDocumento.motivoAssenzaFirma = this.motivoAssenzaFirma;}
      doc["selected"] = event;
    });
    this.selectedDocs = [...this.documenti];
  }

  onModalitaFormazioneChange(event: { value: any; id: string }) {
    let index = this.selectedDocs.findIndex((x) => (x.id = event.id));
    if (index > -1) {
      this.selectedDocs[index].metadatoDocumento.modalitaFormazioneDocumento =
        event.value;
    }
  }

  onSelectChange(event, doc: DocumentoAllegato, name) {
    let x = {
      id: event.id,
      label: event.label,
      rimosso: null,
      descrizione: null,
    };
    doc.metadatoDocumento[name] = x;
    // if (name === 'modalitaFormazioneDocumento') {
    //   this.handleProduttoreEsterno(doc);
    // }
    this.selectedDocs[this.selectedDocs.findIndex(x => x.id === doc.id)] = {...doc};
  }

  onMassiveSelectChange(event, name) {
    if(!event) {
      this[name] = null;
      return;
    }
    const value = {
      id: event.id,
      label: event.label,
      rimosso: null,
      descrizione: null,
    };
    this[name] = value;

    if (!this.selectedDocs?.length) return;
    
    this.selectedDocs.forEach((x) => {
      if (!x.metadatoDocumento) return;
      if (name === 'motivoAssenzaFirma') {
        const isFirmato = x.metadatoFirmaDocumenti?.length > 0;
        const isArchive = this.isArchive(x);

        if (isFirmato || isArchive) {
          x.metadatoDocumento.motivoAssenzaFirma = null;
          return;
        }
      }
      x.metadatoDocumento[name] = value;

      // if (name === 'modalitaFormazioneDocumento') {
      //   this.handleProduttoreEsterno(x);
      // }
    });
  }

  save() {
    this.loading = true;
    this.spinner.show();
    const requests = this.selectedDocs.map((item) => {
      let payload: UpdateMetadatiDocumentoRequest = new UpdateMetadatiDocumentoRequest();
      payload.dataInput = new DataInput(
        this.fascicolo.praticaBase.id,
        this.fascicolo.id,
        this.fascicolo.praticaBase.intestazione.campi.posizionePratica,
        this.fascicolo.posizione,
        this.pratica.tipoPratica.id,
      );
      payload.documento = {...item};
      delete payload.documento["selected"];
      return this.operations.updateMetadatiDocumento(payload);
    });
    forkJoin(requests).subscribe({
      next: (results) => {
        this.dialogRef.close({ response: results, refresh:true });
      },
      error: err => {
        console.log('Errore durante salvataggio', err);
        this.loading = false;
        this.spinner.hide();
      },
      complete: () => {
        this.loading = false;
        this.spinner.hide();
      }
    });
  }

  exit() {
    this.destroy$.next();
    this.destroy$.complete();
    this.dialogRef.close();
  }

  hasFirmaNonValida(doc: DocumentoAllegato): boolean {
    return !!doc?.metadatoFirmaDocumenti?.some(f =>
      f.firmaPresente === true &&
      f.esitoVerifica?.id === 'NON_VALIDA'
    );
  }

  isArchive(file: DocumentoAllegato): boolean {
    let ext = [
      'application/zip', 
      'message/rfc822', 
      'application/vnd.ms-outlook', 
      'application/vnd.rar' , 
      'application/x-rar', 
      'application/x-rar-compressed',
      'application/mbox',
      'application/x-mbox'
    ];
    let isArchive = ext.findIndex(x => x === file.contentType) > -1;
    return isArchive;
  }

  onRefresh(event: Pagination){
    this.currentPage = event.getCurrentPage();
    this.currentItemsPerPage = event.getItemsPerPage();
    this.setCurrentConfigurazioni();
  }

  setCurrentConfigurazioni() {
    const start = this.currentPage * this.currentItemsPerPage;
    const end = start + this.currentItemsPerPage;
    this.documentiPaged = this.documenti.slice(start, end);
  }

  reset() {
    this.documenti = JSON.parse(JSON.stringify(this.documentiOriginal));
    this.selectedDocs = [];
    this.motivoAssenzaFirma = null;
    this.modalitaFormazioneDocumento = null;

    this.documenti.forEach(doc => doc["selected"] = false);

    this.setCurrentConfigurazioni();
    this.cdr.detectChanges();
  }

  private handleProduttoreEsterno(doc: DocumentoAllegato) {
    if (!doc?.metadatoDocumento) return;

    const modalita = doc.metadatoDocumento.modalitaFormazioneDocumento?.id;

    if (this.hasFirmaNonValida(doc)) {

      // caso B → ESTERNO
      if (modalita === 'B') {
        doc.metadatoDocumento.tipoUfficioProduttore = {
          id: 'ESTERNO',
          label: 'Esterno',
          rimosso: null,
          descrizione: null
        };
      }

      // caso A → INTERNO
      if (modalita === 'A') {
        doc.metadatoDocumento.tipoUfficioProduttore = {
          id: 'INTERNO',
          label: 'Interno',
          rimosso: null,
          descrizione: null
        };
      }
    }
  }
}
